import React from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const CenterUpAndDownComponent: MyComponentType<Props> = (props: Props) => {
  const { id } = props;

  return (
    <div id={id} className={'h-full flex flex-col justify-center'}>
      <props.ComponentBasicRender {...toJS(props)} style={{}} key={props.nodeId} />
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/CenterUpAndDownComponentDefinition'));

CenterUpAndDownComponent.definition = {
  id: ComponentIdEnum.CENTER_UP_AND_DOWN_COMPONENT,
  name: '上下居中容器',
  position: 900, // 显示顺序
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/oZeo1jtD5TONnoGVDx5Ju.png?image_process=resize,w_200',
  config: {},
  privateSchema: {}, // 组件自己的属性 不能通用的部分
  category: 'container',
  configForm: ConfigHOC(ConfigForm),
};
